export default __webpack_public_path__ + "static/media/merge.84bd35ee.webp";